import React, { useEffect, useRef, useState } from "react";
import { useHits, useQueryRules } from "react-instantsearch";
import "./ManufacturerSlider.scss";
import ManufacturerSliderArrows from "./ManufacturerSliderArrows";
import ManufacturerSliderItem from "./ManufacturerSliderItem";
import gsap from "gsap";
import { manufacturerItemsAnimation } from "./manufacturer-animations";
import { useGSAP } from "@gsap/react";
import { useMediaQuery } from "react-responsive";

const ManufacturerSlider = (props) => {
    // const dispatch = useDispatch();
    const { hits } = useHits(props);
    const { items } = useQueryRules(props);

    const manufacturerElements =
        items &&
        Object.assign(items)
            .map((element) => {
                return element;
            })
            .filter((key) => key.manufacturerData)
            .map((element) => {
                return element.manufacturerData;
            })
            .flat();

    const matchingSuppliers = hits.map((items) => items);

    const matchedManufacturers = matchingSuppliers.map(
        (element) => element.detail_manufacturer,
    );

    const countManufacturers =
        matchedManufacturers.length > 0
            ? matchedManufacturers.reduce(
                  (acc, element) =>
                      (
                          // eslint-disable-next-line
                          (acc[element] = (acc[element] || 0) + 1), acc
                      ),
                  {},
              )
            : null;

    const sortedCountManufacturers = countManufacturers
        ? Object.keys(countManufacturers)
              .sort((a, b) =>
                  countManufacturers[a] > countManufacturers[b] ? 1 : -1,
              )
              .reverse()
        : null;

    const filteredManufacturers = countManufacturers
        ? manufacturerElements
              .map((element) => element)
              .filter((filter) =>
                  countManufacturers[filter.propertyValue] > 0 ? filter : null,
              )
        : null;

    const sortedManufacturers = filteredManufacturers
        ? filteredManufacturers.sort(
              (a, b) =>
                  sortedCountManufacturers.indexOf(a.propertyValue) -
                  sortedCountManufacturers.indexOf(b.propertyValue),
          )
        : null;

    const boostedManufacturer = "Inwerk";

    const foundIdx = sortedManufacturers
        ? sortedManufacturers.findIndex(
              (el) => el.propertyValue === boostedManufacturer,
          )
        : null;

    const inwerkElement = foundIdx
        ? sortedManufacturers.splice(foundIdx, 1)
        : null;
    inwerkElement && sortedManufacturers.unshift(inwerkElement[0]);

    //  Slider State and Controls
    const [current, setCurrent] = useState(0);
    const nextSlide = () => {
        setCurrent(
            current === sortedManufacturers.length - 1 ? 0 : current + 1,
        );
    };
    const prevSlide = () => {
        setCurrent(
            current === 0 ? sortedManufacturers.length - 1 : current - 1,
        );
    };
    /*  const goToSlide = (slideIndex) => {
        setCurrent(slideIndex);
    }; */

    // resets to first element if results change
    useEffect(() => {
        setCurrent(0);
    }, [hits]);

    const maxManufacturers = 5;

    sortedManufacturers &&
        sortedManufacturers.length >= maxManufacturers &&
        sortedManufacturers.splice(maxManufacturers);

    const sliderItems =
        sortedManufacturers &&
        sortedManufacturers[0] !== undefined &&
        sortedManufacturers.map((element, elementIndex) => {
            return (
                <ManufacturerSliderItem
                    key={elementIndex}
                    currentIndex={current}
                    position={elementIndex}
                    index={elementIndex}
                    link={element.link}
                    headline={element.headline}
                    logo={element.logo_url}
                    description={element.description}
                />
            );
        });

    const sliderArrows = sortedManufacturers &&
        sortedManufacturers.length > 1 && (
            <>
                <ManufacturerSliderArrows
                    nextSlide={nextSlide}
                    previousSlide={prevSlide}
                />
            </>
        );

    const shouldRenderSlider =
        sortedManufacturers?.length > 0 && countManufacturers;

    const componentRef = useRef();

    const isNotMobile = useMediaQuery({
        query: "(min-width: 768px)",
    });
    const timeline = useRef(gsap.timeline());
    useGSAP(
        () => {
            timeline.current.add(manufacturerItemsAnimation(), 0.25);
        },
        {
            dependencies: [isNotMobile && shouldRenderSlider && componentRef],
            scope: componentRef.current,
        },
    );
    return shouldRenderSlider ? (
        <div className="search--manufacturer--slider" ref={componentRef}>
            <div className="slides">{sliderItems}</div>
            {sliderArrows}
        </div>
    ) : null;
};

export default ManufacturerSlider;
